module.exports = __webpack_public_path__ + "img/arrow.c80c21a2.svg";